import { render, staticRenderFns } from "./PortalRegistrationMethod.vue?vue&type=template&id=62d2927d&scoped=true&"
import script from "./PortalRegistrationMethod.vue?vue&type=script&lang=js&"
export * from "./PortalRegistrationMethod.vue?vue&type=script&lang=js&"
import style0 from "./PortalRegistrationMethod.vue?vue&type=style&index=0&id=62d2927d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d2927d",
  null
  
)

export default component.exports